module.exports = __webpack_public_path__ + "img/pic_half.d663bcae.png";